import React, { JSX } from 'react'
import { Box, Image } from '@chakra-ui/react'

import theme from 'styles/theme'

type NavIconProps = {
  type: 'prev' | 'next'
  disabled?: boolean
  onClick: () => void
}

const NavIcon = ({ type, disabled, onClick }: NavIconProps): JSX.Element => {
  const src = type === 'prev' ? 'arrow-left.svg' : 'arrow-right.svg'

  return (
    <Box
      onClick={onClick}
      as={'button'}
      style={{
        height: '24px',
        width: '24px',
        borderRadius: '50%',
        display: 'grid',
        placeItems: 'center',
        border: '1.5px solid',
        borderColor: theme.token('colors.leid.mrkereGrnn'),
        background: 'transparent',
        padding: 0,
        cursor: 'pointer',

        pointerEvents: disabled ? 'none' : 'all',
        opacity: disabled ? 0.5 : 1,

        flexShrink: 0,
      }}
    >
      <Image alt="" src={`/icons/${src}`} height="12px" width="12px" />
    </Box>
  )
}

export default NavIcon
